/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Whether and how a form may migrate to a newer template version.
 * @export
 */
export const MigrationEligibility = {
    Eligible: 'ELIGIBLE',
    EligibleRevertsToDraft: 'ELIGIBLE_REVERTS_TO_DRAFT',
    Locked: 'LOCKED',
    UpToDate: 'UP_TO_DATE'
} as const;
export type MigrationEligibility = typeof MigrationEligibility[keyof typeof MigrationEligibility];


export function instanceOfMigrationEligibility(value: any): boolean {
    for (const key in MigrationEligibility) {
        if (Object.prototype.hasOwnProperty.call(MigrationEligibility, key)) {
            if (MigrationEligibility[key as keyof typeof MigrationEligibility] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MigrationEligibilityFromJSON(json: any): MigrationEligibility {
    return MigrationEligibilityFromJSONTyped(json, false);
}

export function MigrationEligibilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): MigrationEligibility {
    return json as MigrationEligibility;
}

export function MigrationEligibilityToJSON(value?: MigrationEligibility | null): any {
    return value as any;
}

export function MigrationEligibilityToJSONTyped(value: any, ignoreDiscriminator: boolean): MigrationEligibility {
    return value as MigrationEligibility;
}

